import React from 'react'
import GitIcon from '../Icon/GithubLogo'
const Footer = () => {
	return(
		<footer>
			<div>
				<a href='https://github.com/karttofer/parcel-app' target='_blank'>
					<GitIcon/>
				</a>
			</div>
		</footer>
	)
};
export default Footer